import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ComboService } from '../Model/Combo/combo.service';
import { CommonService } from '../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { SessionService } from '../Util/Session/session.service';
import { EmployeeLeaveManagementService } from '../Model/EmployeeLeaveManagement/employee-leave-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';
import { LeaveClosingDetailComponent } from '../leave-closing-detail/leave-closing-detail.component';

@Component({
  selector: 'app-leave-closing-balance-back',
  standalone: true,
  imports: [LoaderComponent, CommonModule, NgSelectModule, FormsModule, DataTablesModule],
  templateUrl: './leave-closing-balance-back.component.html',
  styleUrl: './leave-closing-balance-back.component.scss'
})
export class LeaveClosingBalanceBackComponent {
  isDisabled: boolean = false;
  dtoptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  Keys = [] as any;
  showTable: boolean = false;

  dtOptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: true,
    pageLength: 25,
    lengthMenu: [10, 25, 50, 100],
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    columns: []
  };

  constructor(
    private comboload: ComboService,
    public common: CommonService,
    private toast: ToastService,
    private session: SessionService,
    private leave: EmployeeLeaveManagementService,
    private modalService: NgbModal,
    private download: DownloadSampleService
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit() {
    this.ComboLoad('Branch');
    // this.LeaveBalanceLoad(0, false, '');
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  user: any;
  Branchs: any[] = [];
  Clients: any[] = [];
  Sites: any[] = [];
  TableDatas: any[] = []

  Filter = {
    Date: '' as any,
    BranchId: null,
    ClientId: null,
    SiteId: null,
    Code: '',
    EmpCode: '' as any,
    EmployeeId: null as any,
    EmpType: 'BACK',
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Site') {
      this.Filter.SiteId = null;
      this.Sites = [];
    } else if (Combotype == 'Client') {
      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
      this.Clients = [];
      this.Sites = [];
    }
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': this.Filter.BranchId,
      'ClientId': this.Filter.ClientId,
      'SiteId': this.Filter.SiteId,
      'EmpType': 'BACK',
      'EmpCode': this.Filter.EmpCode
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          } 
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  LeaveBalanceLoad(empmasterid: any, withoutpivot: any, selecttype: any) {
    this.isDisabled = true;
    this.leave.LeaveClosingBalance({
      SelectType: selecttype,
      Empcode: this.Filter.EmpCode,
      EmpMasterID: empmasterid,
      BracnchId: this.Filter.BranchId,
      ClientId: this.Filter.ClientId,
      SiteId: this.Filter.SiteId,
      ShowOnlyClosing: 'C',
      WithoutPivot: withoutpivot,
      EmpType: 'BACK',
      MonthName: '',
      YearName: '',
      UserID: this.user.UserId
    }).subscribe({
      next: (response) => {
        if (empmasterid == 0) {
          this.Keys = response.Table?.length ? Object.keys(response.Table[0]).filter((key: any) => !['EmpCode', 'EmpMasterID'].includes(key)) : [];
          console.log(this.Keys);
          this.initializeComboTable('#summarydata', response.Table)

          this.TableDatas = response.Table;
          // this.showTable = true;
          // // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          // //   dtInstance.destroy();
          // //   this.dtTrigger.next(null);
          // // });
        } else {
          const modalRef = this.modalService.open(LeaveClosingDetailComponent, { size: 'xl', backdrop: 'static' });
          modalRef.componentInstance.data = response.Table;
          modalRef.result.then(
            (result) => {
              if (result) {
                this.LeaveBalanceLoad(0, false, '');
              }
            })
        }
        this.isDisabled = false;
      },
      error: (err: any) => {
        this.isDisabled = false;
      }
    })
  }

  initializeComboTable(selector: string, data: any[]) {
    const tableElement = $(selector);

    if (tableElement.length === 0) {
      console.error(`Table ${selector} not found`);
      return;
    }

    // Proper destroy (ONLY ONCE)
    if ($.fn.dataTable.isDataTable(selector)) {
      $(selector).DataTable().clear().destroy();
      $(selector).empty();
      $(selector).off();
    }

    // define columns
    const columns: any[] = [
      {
        title: '#',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<strong>${meta.row + 1}</strong>`;
        }
      },
      {
        title: 'Action', data: null,
        orderable: false,
        className: 'text-center',
        render: (data: any, type: any, row: any) => {
          return `<i class="bi bi-pencil-square text-warning me-2 edit-btn cursor-pointer" title="Edit"></i>`;
        }
      }
    ];

    for (let i = 0; i < this.Keys.length; i++) {
      columns.push({
        title: this.Keys[i],
        data: this.Keys[i],
      })
    }

    // initialize ONLY ONCE
    const table = $(selector).DataTable({
      data: data,
      columns: columns,
      paging: true,
      searching: true,
      ordering: true,
      autoWidth: false
    });

    // ✅ Handle click using delegation
    $(selector + ' tbody').off('click', '.edit-btn').on('click', '.edit-btn', (event) => {
      const e = table.row($(event.currentTarget).closest('tr')).data() as any;
      this.LeaveBalanceLoad(e.EmpMasterID, true, 'EMPLEAVELIST')
    });
  }

  ExcelDump() {
    if (this.TableDatas.length == 0) {
      this.toast.show({ message: `No Data Found`, type: toastTypeEnum.warning });
    } else {
      this.download.exportToExcelWithProgress(this.TableDatas, 'Employee Leave Details');
    }
  }
}
